import { frontendURL } from '../../../helper/URLHelper';
import Index from './Index.vue';
import Connect from './Connect.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/instagram'),
    name: 'instagram_index',
    component: Index,
    meta: { permissions: ['administrator'] },
  },
  {
    path: frontendURL('accounts/:accountId/instagram/new'),
    name: 'instagram_connect',
    component: Connect,
    meta: { permissions: ['administrator'] },
  },
];
